<template>
    <div class="sidebar-page boxx">
        
        <div class="columns is-desktop">
                
                
                
                <div class="column is-3 is-desktop" v-for="integration in integration_options.filter( i => ['preview', 'api', 'pipedream', 'zapier'].includes(i.id) )">
                <div class="">
                
                   
                <div class="card board">
<div class="card-content">
<div class="media">
                        <div class="media-left">
                           <b-image
                              style="min-width: 4em;"
                              :src="require(`@/images/${integration.img}`)"
                              alt="The Buefy Logo"
                              ratio="1by1"
                              ></b-image>
                        </div>
                        <div class="media-content">
                            
                           <p class="title is-4">{{ integration.title }}</p>
                           <p class="subtitle is-6">{{ integration.desc }}</p>
                           </div>
                        </div>
</div>
<footer class="card-footer">
    
    <a @click="openLink(link)" class="card-footer-item" v-for="link in integration.links">
        <i class="fas fa-url" aria-hidden="true"></i>&nbsp;
        {{ link.title }}
    </a>
   
</footer>
</div>
                  
               
            </div>
        </div>
             </div>
             <div class="columns is-desktop">
                <div class="column is-3 is-desktop" v-for="integration in integration_options.filter( i => [ 'sheets', 'marketplace', 'docker', 'hf'].includes(i.id) )">
                    <div class="">
                
                   
                <div class="card board">
<div class="card-content">
<div class="media">
                        <div class="media-left">
                           <b-image
                              style="min-width: 4em;"
                              :src="require(`@/images/${integration.img}`)"
                              alt="The Buefy Logo"
                              ratio="1by1"
                              ></b-image>
                        </div>
                        <div class="media-content">
                            
                           <p class="title is-4">{{ integration.title }}</p>
                           <p class="subtitle is-6">{{ integration.desc }}</p>
                           </div>
                        </div>
</div>
<footer class="card-footer">    
    
    <a @click="openLink(link)" class="card-footer-item" v-for="link in integration.links" v-if="integration.available" >
        <i class="fas fa-url" aria-hidden="true"></i>&nbsp;
        {{ link.title }}
    </a>
    <a v-else class="card-footer-item"><b-tag >Coming soon</b-tag></a>
</footer>
</div>
                  
               
            </div>
        </div>
             </div>
              
             <div class="columns is-desktop">
            <div class="column is-half is-offset-0 is-desktop">
      <b-field message="API Key">
        <b-input v-on:focus="$event.target.select()"
           ref="apikey" 
           readonly 
           :value="getApiKey()" expanded type="text"></b-input>
        <b-button type="is-light" @click="copy">Copy</b-button>
      </b-field>
      <b-field message="Project ID">
        <b-input v-on:focus="$event.target.select()"
           ref="projectId" 
           readonly 
           :value="project.id" expanded type="text"></b-input>
        <b-button type="is-light" @click="copyProjectId">Copy</b-button>
      </b-field>
    </div>
    </div>

             <p><b-field label="Do you have any integration suggestions?" message="We're here to enhance your experience. Share your ideas and let's make it happen together!"></b-field>
                <b-button tag="a" href="https://metatext.canny.io/report-an-issue" target="_blank">Request an integration</b-button>
            </p>
            


     <b-modal
          v-model="isModelBulkOpen"
          has-modal-card
          trap-focus
          :destroy-on-hide="true"
          aria-role="dialog"
          aria-label="Model"
          aria-modal
          scroll="keep">
          <template #default="props">
            <div class="modal-card box" style="min-width: 60em; width: auto">
                <div class="modal-card-body">
                    <Playground :isBatch="true" :apiKey="getApiKey()" :inferenceUrl="getInferenceUrl()" :currentUser="currentUser" :models="project.models" :project="project"/>
                </div>
            </div>
          </template>
      </b-modal>

      <b-modal
          v-model="isModelPreviewOpen"
          has-modal-card
          trap-focus
          :destroy-on-hide="false"
          aria-role="dialog"
          aria-label="Model"
          aria-modal
          scroll="keep">
          <template #default="props">
            <div class="modal-card box" style="min-width: 60em; width: auto">
                <div class="modal-card-body">
                    <Predict :apiKey="getApiKey()" :currentUser="currentUser" :project="project" :modelId="project.id"/>
                </div>
            </div>
          </template>
      </b-modal>

      <b-modal
          v-model="isModelAPIOpen"
          has-modal-card
          trap-focus
          :destroy-on-hide="true"
          aria-role="dialog"
          aria-label="Model"
          aria-modal
          scroll="keep">
          <template #default="props">
            <div class="modal-card box" style="min-width: 60em; width: auto">
                <div class="modal-card-body">
                    <DeployInfo :apiKey="getApiKey()" :inferenceUrl="getInferenceUrl()" :models="project.models" :project="project"/>
                </div>
            </div>
          </template>
      </b-modal>

    </div>
 </template>
 <script>
 
    import DeployInfo from '@/components/DeployInfo.vue'
    // import Playground from "@/dashboard/Project/DataGrid.vue";
    import Predict from "@/dashboard/Project/PredictPreview.vue";
    
    export default {

    props: ["stepId", "tabId", "project", "projectModels", "projectDatasets", "currentUser", "projects"],
    name: "Connect",
    data: function() {
        return {
            isModelAPIOpen: false,
            isModelBulkOpen: false,
            isModelPreviewOpen: false,
            all_users_api_key: 'GcD8CJgm1i4ELinYrXLbt4pAMi5gXptN9FuB5MwI',
            holder: [],
            deployments: [],
            integration_options: [
            {
                id: 'preview',
                title: 'Predict Preview',
                img: 'preview.svg',
                desc: 'Test your model online',
                available: true,
                links: [{
                    title: "Open",
                    modal: 'isModelPreviewOpen'
                }],
            },
            {
                id: 'bulk',
                title: 'Bulk Model Predict',
                img: 'api.png',
                desc: 'Bulk inference with CSV and export',
                available: true,
                links: [{
                    title: "Open",
                    modal: 'isModelBulkOpen'
                }],
            },
            {
                id: 'api',
                title: this.project.name+' API',
                img: 'api.png',
                desc: 'Metatext API endpoint',
                available: true,
                links: [{
                    title: "Documentation",
                    external: `https://docs.metatext.ai`
                },{
                    title: "API Deployment",
                    modal: 'isModelAPIOpen'
                }],
            },
            {
                id: 'marketplace',
                title: 'AWS Marketplace',
                img: 'aws.svg',
                desc: 'Integrate into your AWS stack',
                available: true,
                links: [{
                    title: "Get access",
                    external: `https://tally.so/r/3EdBKl`
                }],
            },
            {
                id: 'webapp',
                title: 'WebApp',
                img: 'api.png',
                desc: 'WebApp to use models',
                available: false,
                links: [{
                    title: "Create a webapp",
                    router: `/spaces/${this.project.id}`
                }],
            },
            
            {
                id: 'pipedream',
                title: 'Pipedream',
                img: 'pipedream.png',
                desc: '1000+ triggers, actions and apps',
                available: true,
                links: [{
                    title: "Connect to Pipedream",
                    external: 'https://pipedream.com/apps/metatext-ai-inference-api?metatext-ai'
                }],

            },
            {
                id: 'zapier',
                title: 'Zapier',
                img: 'zapier.png',
                desc: '6000+ apps and integrations',
                available: false,
                links: [{
                    title: "Connect to Zapier",
                    external: 'https://zapier.com/apps/metatext/integrations'
                }],
            },
            {   
                id: 'sheets',
                title: 'Google Sheets',
                img: 'google-Sheets-logo.svg',
                desc: 'Use your model into spreadsheets',
                available: false,
                links: [{
                    title: "Connect Workspace Marketplace",
                    external: 'https://sheets.com'
                }],
            },
            {   
                id: 'docker',
                title: 'Private Deploy',
                img: 'docker.svg',
                desc: 'Docker image on your infra',
                available: true,
                links: [{
                    title: "Get a license",
                    external: 'https://tally.so/r/3EdBKl'
                }],
            },
            {   
                id: 'hf',
                title: 'Hugging Face',
                img: 'huggingface.svg',
                desc: 'Export datasets and models',
                available: true,
                links: [{
                    title: "Push to Hub",
                    external: 'https://tally.so/r/3EdBKl'
                }],
            }
            ],
      }},
      components: { 
        Predict,
        DeployInfo,
    },
      methods: {
        openLink(link){
            // if modal
            if(link.modal){
                this[link.modal] = true
            } else if(link.external){
                window.open(link.external, '_blank')
            } else if (link.router){
                this.$router.push(link.router)
            }
        
        },
        addDeployment(type){
            this.deployments.push(type)
        },
        getInferenceUrl() {
                let endpoints = {
                    classification: 'classify',
                    extraction: 'extract',
                }
                let endpoint_name = endpoints[this.project.type]
                let endpoint_version = 'v2'
                return `https://api.metatext.ai/${endpoint_version}/${endpoint_name}/${this.project.id}`
            },
        getApiKey(){
                if(this.currentUser && "apiKey" in this.currentUser && this.currentUser.apiKey != undefined){
                  return this.currentUser.apiKey
                } else {
                  return this.all_users_api_key
                }
            },
            copy() {
                this.$refs.apikey.focus();
                document.execCommand('copy', true);
            },
            copyProjectId() {
                this.$refs.projectId.focus();
                document.execCommand('copy', true);
            },
      },
      watch: {
    
      },
    };
      
 </script>
 <style lang="scss" scoped>
 
 </style>